export const getVaccareseFranceData = () => ({
  name: "Vaccarèse",
  country: "France",
  description: "Vaccarèse est un cépage rouge rare originaire du sud de la France, principalement utilisé dans les assemblages de Châteauneuf-du-Pape où il apporte finesse et notes herbacées.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "1%", description: "Cépage rare, apportant finesse et notes herbacées" },
    { name: "Côtes du Rhône", area: "10 ha", percentage: "0.3%", description: "Utilisé dans quelques assemblages traditionnels" },
    { name: "Languedoc-Roussillon", area: "5 ha", percentage: "0.1%", description: "Cultivé dans quelques domaines expérimentaux" },
    { name: "Autres", area: "5 ha", percentage: "0.1%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#6d2c7a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage rare et difficile à cultiver, sensible aux maladies",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    red: "Vins rouges fins avec des notes herbacées, des tanins doux et de l'élégance"
  },
  foodPairing: "Viandes blanches, volailles, poissons, cuisine provençale, fromages frais",
  history: "Vaccarèse est un cépage très ancien et rare, mentionné dans les textes historiques. Son nom pourrait être lié à la ville de Vacqueyras. Il est aujourd'hui principalement cultivé dans Châteauneuf-du-Pape où il apporte une finesse et des notes herbacées uniques aux assemblages."
}); 